<template>
  <fin-data-loader :resolver="getBackendMaintenanceStatus">
    <template #content>
      <v-row v-if="maintenanceStatus && maintenanceStatus !== 'OK'" class="justify-center py-0 my-0">
        <v-col cols="12" lg="2" sm="3">
          <v-img v-style:maxWidth="$valueByBreakpoint({xs: '50%', sm: '100%', xl: '270px'})"
                 :src="require('@/assets/workInProgress/coming-soon.svg')"
                 contain/>
        </v-col>
        <v-col cols="12" lg="auto" sm="9">
          <p v-html="bannerTextHtml"/>
        </v-col>
      </v-row>
      <v-row v-else-if="maintenanceStatus && showNoMaintenanceInfo">
        <v-col cols="12" lg="2" sm="3">
          <v-img v-style:maxWidth="$valueByBreakpoint({xs: '50%', sm: '100%', xl: '270px'})"
                 :src="require('@/assets/workInProgress/coming-soon.svg')"
                 contain/>
        </v-col>
        <v-col cols="12" lg="auto" sm="9">
          <p v-html="noMaintenanceTextHtml"></p>
        </v-col>
      </v-row>
    </template>
  </fin-data-loader>
</template>

<script>
import {API} from "@/plugins/finAmplifyModules"
import {getSystemStatus} from "@/js/finQueries"
import {onUpdateSystemStatus} from "@/js/finSubscriptions"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import FinDataLoader from "@/components/common/DataLoader"
import {mapGetters} from "vuex"

export default {
  name: 'FinMaintenanceInfo',
  components: {FinDataLoader},
  props: {
    showNoMaintenanceInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maintenanceStatus: 'OK',
      maintenanceSystemStatusId: 'FINCRAFT_APPLICATION',
      bannerTextHtml: `<p>Liebe:r finCraft Nutzer:in,</p><p>wir sind gerade dabei, unser Angebot zu verbessern.</p><p>Durch die Wartungsaktivitäten kann es deshalb zu Störungen und Fehlermeldungen kommen. Wir bitten um dein Verständnis.</p><p>Viele Grüße,<br/>Dein finCraft-Team</p>`,
      noMaintenanceTextHtml: `<p>Liebe:r finCraft Nutzer:in,</p><p>aktuell finden keine Wartungsaktivitäten statt.</p><p>Viele Grüße,<br/>Dein finCraft-Team</p>`
    }
  },
  mixins: [SubscriptionHandler],
  computed: {
    ...mapGetters('auth', ['publicQueryAuthMode']),
  },
  methods: {
    async getBackendMaintenanceStatus() {
      try {
        const result = await API.graphql({
          query: getSystemStatus,
          variables: {
            id: this.maintenanceSystemStatusId
          },
          authMode: this.publicQueryAuthMode
        })
        this.maintenanceStatus = result.data.getSystemStatus.status
      } catch (error) {
        console.error("getMaintenanceStatus failed", error)
        this.maintenanceStatus = undefined
      }
      this.subscribeStatusMutations()
    },
    handleMaintenanceStatusSubscription(newData) {
      this.maintenanceStatus = newData.data.onUpdateSystemStatus.status
    },
    subscribeStatusMutations() {
      this.subscribeToChanges(
        {id: this.maintenanceSystemStatusId},
        onUpdateSystemStatus,
        (item) => {
          return {id: item.id}
        },
        this.handleMaintenanceStatusSubscription,
        'AWS_IAM'
      )
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
